import theme from '@styles/theme';
export default {
  container: (color: string, isActive: boolean) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    color: isActive ? theme.rawColors.darkGrey600 : theme.rawColors.lightGrey700,
    div: {
      '&:first-of-type': {
        height: 8,
        width: 8,
        minWidth: 8,
        maxWidth: 8,
        minHeight: 8,
        maxHeight: 8,
        borderRadius: '50%',
        display: 'inline-block',
        backgroundColor: color,
        transform: 'translateY(4px)',
        mr: '4px'
      }
    },
    p: {
      color: theme.rawColors.darkGrey700
    }
  })
};